// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@steiner/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { informationStyles } from "@steiner/Overrides/Widgets/InvoiceDetails/InvoiceDetailsInformation";
import { color, mergeWithCss, xScreen } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

informationStyles.invoiceInformationGridContainer = {
    gap: 12,
    css: css`
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 24px;
    `,
};
informationStyles.informationGridContainer = {
    css: css`
        width: 100%;
        display: grid;
        grid-template-columns: repeat(2, 1fr);

        padding-bottom: 24px;
        border-bottom: 1px solid ${color("common.border")};
        margin-bottom: 24px;

        ${xScreen("lte", "md")} {
            width: 100%;
        }

        ${xScreen("lte", "xs")} {
            grid-template-columns: 1fr;
        }
    `,
};

informationStyles.headingAndTextStyles = {
    ...xOrderInformationStyles.headingAndTextStyles,
};

informationStyles.invoiceNotesGridItem = {
    css: css`
        grid-column: 1 / 3;
    `,
};

informationStyles.billingAddressGridItem = {
    width: [6, 6, 6, 6, 6],
    css: css`
        order: 1;
        ${xScreen("lte", 350)} {
            max-width: 100%;
            flex-basis: 100%;
        }
    `,
};
informationStyles.shippingAddressGridItem = {
    width: [6, 6, 6, 6, 6],
    css: css`
        order: 2;
        ${xScreen("lte", 350)} {
            max-width: 100%;
            flex-basis: 100%;
        }
    `,
};

informationStyles.linkStyle = {
    typographyProps: {
        size: 14,
        lineHeight: "18px",
    },
};

informationStyles.billingAddressStyle = {
    titleText: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            css: css`
                margin-bottom: 0;
                padding-bottom: 8px;
            `,
        }),
    },
    headerText: {
        css: css`
            display: none;
        `,
    },
    wrapper: {
        css: css`
            margin-bottom: 24px;
        `,
    },
};
informationStyles.shippingAddressStyle = {
    wrapper: {
        css: css`
            margin-bottom: 24px;
        `,
    },
    titleText: {
        css: css`
            display: none;
        `,
    },
    headerText: {
        ...mergeWithCss(xOrderInformationStyles.address?.heading, {
            css: css`
                margin-bottom: 0;
                padding-bottom: 8px;
            `,
        }),
    },
};
